<ul>
    @for (opcao of opcoes(); track opcao.link) {
        <li>
            <a
                class="item"
                [class.desabilitado]="!opcao.disponivel"
                [routerLink]="opcao.disponivel ? opcao.link : null"
                [attr.aria-disabled]="!opcao.disponivel || null"
            >
                <img class="ilustracao" [src]="opcao.ilustracao" alt="" />
                <span class="rodape">
                    <span class="titulo heading4 medium">{{ opcao.nome }}</span>
                    <span class="seta" appIcone="arrow-up-right" aria-hidden="true"></span>
                </span>
            </a>
        </li>
    }
</ul>
